import { convertArrayToHashMap } from '../../../../shared/libraries/dataSets'
import { splitOverlaysIntoCitiesWithPostcodes } from '../../../../Components/CampaignQuote/util'

/**
 *
 * @param {object} args
 * @param {string} args.countryCode
 * @param {object[]} args.overlays
 * @param {number} args.overlays[].latitude
 * @param {number} args.overlays[].longitude
 * @param {object[]} args.cities
 */
export const generateCampaignSummary = ({ countryCode, overlays, cities }) => {
  const citiesMap = convertArrayToHashMap(cities, 'id')
  return splitOverlaysIntoCitiesWithPostcodes({
    overlays,
    citiesMap,
    countryCode,
  })
}



// WEBPACK FOOTER //
// ./src/Containers/Form/Campaigns/CreateEditCampaign/util.js